<div id="item-{{story.id}}" class="step">
  <ng-content></ng-content>
</div>
